<template>
  <div class="compose" v-if="active" @click.stop>
    <div class="header section">
      <a class="close" @click="close">
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
      <h2>{{$t('more.discussion')}}</h2>
    </div>
    <div class="section">
      <div class="col-12 mb-2">
        <div class="d-flex userinfo-container">

          <AvatarImage :userId="userInfo ? userInfo.uuid : ''" :size="48"/>

          <div class="p-2 d-flex flex-column" style="align-items: flex-start;">
            <span class="profile-name">{{patientName}}</span>
            <span class="profile-subtitle">{{$t(patientGender)}} - {{patientAge}} {{$t('more.post_year')}}</span>
          </div>
        </div>
      </div>

      <Discussion v-if="!tableEditorActive" ref="discussion" :comments="comments" @send="send" @drugsTable="drugsTable"/>
      <DiscussionTableEditor v-else @canceled="drugsTableCanceled" @ok="drugsTableOk"/>
    </div>
    <div class="footer section">
      <p class="discussion-footer">{{$t('discussion.next_refresh', { interval: nextFetch })}}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Discussion from './Discussion.vue'
import EmojiArea from '@/components/EmojiArea.vue'
import AvatarImage from '@/components/AvatarImage.vue'
import DiscussionTableEditor from './DiscussionTableEditor.vue'
import {yearDifference} from '@/_helpers'

export default {
  components: {
    Discussion,
    EmojiArea,
    AvatarImage,
    DiscussionTableEditor
  },
  data () {
    return {
      active: false,
      tableEditorActive: false,
      testUuid: String,
      userInfo: Object,
      unsubscribe: null,
      refreshIntervalId: null,
      refreshInterval: 0
    }
  },
  computed: {
    ...mapState({
      comments: state => state.comment.comments,
      commentsStatus: state => state.comment.commentsStatus,
      postCommentStatus: state => state.comment.postCommentStatus
    }),
    patientName () {
      if (!this.userInfo) {
        return '...'
      }
      return this.userInfo.first_name + ' ' + this.userInfo.last_name
    },
    patientGender () {
      if (!this.userInfo) {
        return '...'
      }
      return this.userInfo.gender === 2 ? 'gender.male' : (this.userInfo.gender === 1 ? 'gender.female' : 'gender.other')
    },
    patientAge () {
      if (!this.userInfo) {
        return '...'
      }
      return yearDifference(this.userInfo.birth_date)
    },
    nextFetch () {
      return 30 - this.refreshInterval
    }
  },
  methods: {
    ...mapActions('comment', ['postComment', 'getComments', 'clearComments']),
    open (testUuid, userInfo) {
      console.log('open', testUuid, userInfo)
      if (!userInfo) {
        console.warn('user info not found')
        return
      }
      if (this.testUuid === testUuid) {
        return
      }

      this.clearComments()
      this.testUuid = testUuid
      this.userInfo = userInfo
      this.active = true
      this.fetchComments()

      this.refreshIntervalId = setTimeout(this.fetchCommentsTimeout, 1000)
    },
    close () {
      this.active = false
      this.testUuid = null
      this.userInfo = null
    },
    drugsTable () {
      this.tableEditorActive = true
    },
    send (text) {
      this.postComment({
        text: text,
        test_uuid: this.testUuid,
        type: 'text'
      })
    },
    fetchComments () {
      this.refreshInterval = 0
      this.getComments(this.testUuid)
    },
    fetchCommentsTimeout () {
      if (!this.testUuid) {
        return
      }

      this.refreshInterval++
      if (this.refreshInterval >= 30 && this.testUuid !== null) {
        this.fetchComments()
      }
      this.refreshIntervalId = setTimeout(this.fetchCommentsTimeout, 1000)
    },
    drugsTableCanceled () {
      this.tableEditorActive = false
    },
    drugsTableOk (items) {
      var filteredItems = items.filter(item => {
        if (!item.hasOwnProperty('name')) {
          return false
        }
        return item.name.length > 0
      })
      if (filteredItems.length === 0) {
        return
      }
      var tableString = `| نام | توضیحات |\r\n| --------:| -----------:|\r\n`
      filteredItems.forEach(item => {
        let desc = ''
        if (item.hasOwnProperty('description') && item.description) {
          desc = item.description
        }
        tableString += `| ${item.name} | ${desc} |\r\n`
      })

      this.postComment({
        text: tableString,
        test_uuid: this.testUuid,
        type: 'md'
      })

      this.tableEditorActive = false
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'comment/postCommentSuccess' || mutation.type === 'comment/getCommentsSuccess') {
        this.$refs.discussion.scrollToBottom()
      }
    })
  },
  mounted () {
    this.tableEditorActive = false
  },
  destroyed () {
    this.unsubscribe()
  }
}
</script>

<style scoped>
.compose {
  background: #fff;
  box-shadow: 0 1px 2px rgba(#000, .2);
  position: fixed;
  bottom: 0;
  left: 10px;
  width: 510px;
  z-index: 100;
}
.header {
  background: #404040;
  border-color: #404040;
}
.close {
  float: right;
  color: #b2b2b2;
  font: 16px/27px sans-serif;
  height: 28px;
  width: 28px;
  margin-top: -6px;
  margin-right: -6px;
  text-align: center;
  text-decoration: none;
}
.close:hover {
  color: #fff;
  background: #737373;
}
h2 {
  font: inherit;
  color: #fff;
  margin: 0;
}
.section {
  border: 1px solid #CFCFCF;
  border-bottom: none;
  padding: 10px;
}
.fit {
  overflow: hidden;
}
.footer {
  overflow: hidden;
  background: #F5F5F5;
}
.discussion-footer {
  text-align: start;
  font-size: smaller;
}
</style>



// WEBPACK FOOTER //
// src/views/DiscussionDialog.vue